import React, { useState } from "react";
import { Button, Checkbox, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function MoveInCancelled({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Form.Item label="1" name="moveInPage" valuePropName="checked">
              <Checkbox>go to the move in page</Checkbox>
            </Form.Item>
            <Form.Item label="2" name="cancelMoveIn" valuePropName="checked">
              <Checkbox>click cancel move in in SayEagle</Checkbox>
            </Form.Item>
            <Form.Item label="3" name="notifyOwner" valuePropName="checked">
              <Checkbox>notify owner that move in was cancelled</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default MoveInCancelled;
